 
import PropertyBreadcrumb from "../../commonComponents/breadcrumbs/PropertyBreadcrumb";
import SortBy from "../../commonComponents/SortBy";
import GridView from "../../commonComponents/gridView";

const PropertyThumbListContainer = () => {
  return (
    <>
      <PropertyBreadcrumb />
      <SortBy />
      <GridView type="property" sectionClass="property-list property-thumb-section property-inner-section" gridType="list-view" gridSize={1} view="multiple" />
    </>
  );
};

export default PropertyThumbListContainer;
